import React, { useEffect, useState } from "react";
import { Button, message } from "antd";

import AddPatientModal from "./AddPatientModal";
import AddPatientItem from "./AddPatientItem";
import { controller } from "../controller";
import { isNotEmpty } from "../../../utils";
import { patientInputFilterQuery } from "../utils";

export default function AddPatient({ boardId, onPatientSelection, selectedPatientIds, onAddNewPatient }) {
  const [showAddPatientModal, setShowAddPatientModal] = useState(false);
  const [patients, setPatients] = useState(null);
  const [page, setPage] = useState(1)
  const [search, setSearch] = useState("")

  useEffect(() => {
    if (search) return;
    const getPatients = async () => {
      try {
        const response = await controller.getPatientsByOffice(boardId, page);
        setPatients(response.json.results);
        // console.log("patients", response.json.results)
      } catch (err) {
        console.error("Error fetching patients:", err);
      }
    };
    getPatients();
  }, [boardId, search]);

  const handlePatientSelection = (patientId, isSelected) => {
    // Pass the selection up to parent
    onPatientSelection(patientId, isSelected);
  };

  useEffect(() => {
    if (!search) return;

    async function searchBoardPatient() {
      try {
        const queryParams = patientInputFilterQuery(search, "manual");
        // Check if we have valid query parameters
        if (queryParams.toString().length === 0) {
          console.log("No valid search criteria found");
          return;
        }
        const response = await controller.getPatientsByOffice(boardId, page, queryParams);
        setPatients(response.json.results)
      } catch (err) {
        message.error("Something went wrong while searching for patient");
        console.error(err);
      }
    }
    searchBoardPatient();
  },[search]);

  return (
    <div style={{ padding: "0 15px", margin: "0 10px" }}>
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 20 }}>
        <p style={{ marginBottom: 0, fontSize: 16, fontWeight: 400 }}>Add Patient</p>
        <Button type="primary" style={{ fontSize: 12, padding: "0 20px" }} onClick={() => setShowAddPatientModal(true)}>
          New Patient
        </Button>
      </div>

      <input type="text" style={{ borderRadius: 7, border: "1px solid #6B43B5" }} placeholder="Search Patient" value={search} onChange={(e) => setSearch(e.target.value)}/>

      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: 10,
          marginTop: 10,
          height: 408,
          overflowY: "auto",
        }}
        className="custom-scroll"
      >
        {patients && isNotEmpty(patients) && 
          patients.map((patient) => (
            <AddPatientItem key={patient.id} patient={patient} onSelectionChange={handlePatientSelection} isSelected={selectedPatientIds.includes(patient.id)} />
          ))
        }
      </div>

      <AddPatientModal showAddPatient={showAddPatientModal} setShowAddPatient={setShowAddPatientModal} onAddNewPatient={onAddNewPatient}/>
    </div>
  );
}
